import axios from "axios";
import { axiosWithAuth } from "../axiosWithAuth";
import { API_BASE_URL } from "../env";
import {
  EP_ADMIN_INVITE_ALL,
  EP_ADMIN_ORPHANED_COMPANIES,
  EP_ADMIN_RESEND,
  EP_CLAIM_INFO,
  EP_REQUEST_NEW_LINK,
  EP_SUBMIT_CLAIM,
} from "./api";

// --- Admin (authenticated) ---

export const getOrphanedCompaniesService = async () => {
  let server = API_BASE_URL + EP_ADMIN_ORPHANED_COMPANIES.path;
  return await axiosWithAuth(server, {
    method: EP_ADMIN_ORPHANED_COMPANIES.method,
  });
};

export const bulkInviteOrphanedCompaniesService = async () => {
  let server = API_BASE_URL + EP_ADMIN_INVITE_ALL.path;
  return await axiosWithAuth(server, {
    method: EP_ADMIN_INVITE_ALL.method,
  });
};

export const resendCompanyRecoveryService = async (requestBody?: any) => {
  let server = API_BASE_URL + EP_ADMIN_RESEND.path;
  let body = requestBody ? requestBody : EP_ADMIN_RESEND.requestBody;
  return await axiosWithAuth(server, {
    method: EP_ADMIN_RESEND.method,
    data: { ...body },
  });
};

// --- Public (unauthenticated) ---

export const getCompanyClaimInfoService = async (token: string) => {
  let server = API_BASE_URL + EP_CLAIM_INFO.path;
  return await axios(server, {
    method: EP_CLAIM_INFO.method,
    params: { token },
  });
};

export const submitCompanyClaimService = async (requestBody?: any) => {
  let server = API_BASE_URL + EP_SUBMIT_CLAIM.path;
  let body = requestBody ? requestBody : EP_SUBMIT_CLAIM.requestBody;
  return await axios(server, {
    method: EP_SUBMIT_CLAIM.method,
    data: { ...body },
  });
};

export const requestNewCompanyRecoveryLinkService = async (requestBody?: any) => {
  let server = API_BASE_URL + EP_REQUEST_NEW_LINK.path;
  let body = requestBody ? requestBody : EP_REQUEST_NEW_LINK.requestBody;
  return await axios(server, {
    method: EP_REQUEST_NEW_LINK.method,
    data: { ...body },
  });
};
